import { Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { AssetStore } from "../../../assets/AssetsStore";
import { BlackAdd, BlueAdd, ClockSmall } from "../../../assets/Logos/Icons";
import AddDataModal from "../../PrintPrescription/Components/Modals/AddDataModal/AddDataModal";
import { PrescriprionContext } from "../../PrintPrescription/PrintPrescription";
import CovidDataPicker from "../CovidDataPicker/CovidDataPicker";
import Searchbox from "../SearchBox/Searchbox";
import styles from "./index.module.scss";
import Textarea from "react-expanding-textarea";

function DataBoxNote({
  data,
  haveNote,
  name,
  addTitle,
  initialData,
  handleSearch,
  handleAdd,
  toggle,
  onChangeNote,
  noteValue,
  haveCovidData,
  title,
  haveselect
}) {
  const [isAddOpen, setAddOpen] = useState(false);
  const [searchValues, setSearchValues] = useState([]);
  let [selected, setSelected] = useState(null);
  const [selectedData, setSelectedData] = useState([]);
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);
  const [textareaHeight, setTextareaHeight] = useState("auto");

  useEffect(() => {
    const textarea = document.getElementById("noteTextarea");
    if (textarea) {
      setTextareaHeight(`${textarea.scrollHeight}px`);
    }
  }, [noteValue]);

  const addData = (e) => {
    handleAdd(e.name);
    handleSelectData({ name: e.name });
  };

  const isSelected = (datas) => {
    let { name } = datas;
    //let data = [...selectedData];
    let data = selectedData;
    if (data && data.length > 0) {
      let res = data.filter((e) => e.name === name);
      //console.log(res)
      return res && res.length > 0;
    }
  };

  useEffect(() => {
    setSearchValues(createSearchOptionsWithData(initialData));
  }, [initialData]);

  const createSearchOptionsWithData = (data) => {
    if (data && data.length > 0) {
      let result = [...data].sort((a, b) => a.name.localeCompare(b.name));
      result = result.map((e) => ({ label: e?.name, value: e?.name }));
      return result;
    } else {
      return [];
    }
  };

  let handleAddIconClick = (e, name) => {
    e.stopPropagation();
    if (selectedData.filter((item) => item === name).length > 0) {
      handleUnSelectData(name);
    } else {
      handleSelectData(name);
    }
    toggle(name);
  };

  const handleSelectData = (name) => {
    setSelectedData([...selectedData, name]);
  };

  // const pushToWholeData = (key, data) => {
  //   handleWholeData(key, data);
  // };

  // useEffect(() => {
  //   if (selectedData?.length > 0) {
  //     pushToWholeData(title, selectedData);
  //     pushToWholeData("is" + title, true);
  //   } else {
  //     pushToWholeData(title, "");
  //     pushToWholeData("is" + title, false);
  //   }
  // }, [selectedData]);

  const handleSubmissionData = (data) => {
    if (data) {
      setSelectedData(data);
    }
  };

  // useEffect(() => {
  //   if (wholeData[title] !== selectedData) {
  //     handleSubmissionData(wholeData[title]);
  //   }
  // }, [wholeData?.[title]]);

  const handleUnSelectData = (name) => {
    setSelectedData(selectedData.filter((item) => item.name !== name.name));
  };

  const handleSearchBox = (value) => {
    let _item = initialData.filter((e) => e.name == value)[0];
    let _isSelected = selectedData.filter((e) => e.name == value)[0];

    if (!_isSelected) {
      toggle(_item);
      handleSelectData(_item);
    }
    setSelected(() => _item);
    setSearchValues(createSearchOptionsWithData(initialData));
  };

  const isInSearch = (e, data) => {
    for (let i = 0; i < e.length; i++) {
      if (e[i].toLowerCase() !== data?.name[i].toLowerCase()) {
        return false;
      }
    }
    return true;
  };

  const handleOnSearch = (e) => {
    if (initialData && initialData.length > 0 && e) {
      let filterData = initialData.filter((option) => isInSearch(e, option));
      setSearchValues(createSearchOptionsWithData(filterData));
    } else setSearchValues([]);
  };

  const noteChange = () => {};

  const handleKeyDown = (e) => {
    if (e.key === "%") {
      e.preventDefault();
    }
  };

  const splitTextIntoChunks = (text, chunkSize) => {
    const words = text.split(" ");
    const chunks = [];
    let currentChunk = "";

    for (let i = 0; i < words.length; i++) {
      if ((currentChunk + words[i]).length <= chunkSize) {
        currentChunk += words[i] + " ";
      } else {
        chunks.push(currentChunk.trim());
        currentChunk = words[i] + " ";
      }
    }

    if (currentChunk.trim().length > 0) {
      chunks.push(currentChunk.trim());
    }

    return chunks;
  };

  const renderSplitText = (text) => {
    return splitTextIntoChunks(text, 50).map((chunk, index) => (
      <React.Fragment key={index}>
        {index !== 0 && <br />}
        {chunk}
      </React.Fragment>
    ));
  };

  return (
    <>
      <div className={styles.data_box_container}>
        <div className={styles.header}>
          <div className={styles.searchBox}>
            {/* <input type="text" placeholder='Search' />
        <img src={AssetStore.managePrescription.search} alt="" /> */}

            {/* <Select
                            suffixIcon={<img src={AssetStore.managePrescription.search} alt="" />}
                            onSelect={handleSearch ? handleSearch : () => { }}
                            getPopupContainer={trigger => trigger.parentNode}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={createSearchOptions()}
                        /> */}

            {/* <Searchbox
              value={selected}
              options={searchValues}
              onSelect={handleSearchBox}
              onSearch={handleOnSearch}
              placeholder="Search"
            /> */}
          </div>

          {/* <button
            className={styles.add_new_button}
            onClick={() => {
              setAddOpen(true);
            }}
          >
            <span>Add new</span>
            <BlackAdd />
          </button> */}
        </div>

        <div className={styles.body} >
          {/* <div className={styles.caption}>
            <ClockSmall />
            {name}
          </div> */}

          <div className={styles.data_list_wrap}>
            <div className={styles.data_list}>
              {data &&
                data.length > 0 &&
                data.map((each, key) => {
                  if (isSelected(each)) {
                    return (
                      <div
                        // onClick={() => { toggle && toggle(each) }}
                        className={`${styles.data_list_item} ${
                          isSelected(each) && styles.data_list_item_selected
                        }`}
                        key={key}
                      >
                        <div>{renderSplitText(each?.name)}</div>
                        <div
                          onClick={(e) => {
                            handleAddIconClick(e, each);
                          }}
                          className={`${styles.addIcon} ${
                            !isSelected(each)
                              ? styles.addIconSelected
                              : styles.addIconNotSelected
                          }`}
                        >
                          <BlueAdd isSelected={isSelected(each)} scale={0.7} />
                        </div>
                      </div>
                    );
                  }
                })}
            </div>

            <div className={styles.data_list}>
              {data &&
                data.length > 0 &&
                data.slice(0, 10).map((each, key) => {
                  if (!isSelected(each)) {
                    return (
                      <div
                        onClick={(e) => {
                          toggle && toggle(each);
                          handleAddIconClick(e, each);
                        }}
                        className={`${styles.data_list_item} ${
                          isSelected(each) && styles.data_list_item_selected
                        }`}
                        key={key}
                      >
                       <div>{renderSplitText(each?.name)}</div>
                        <div
                          onClick={(e) => {
                            handleAddIconClick(e, each);
                          }}
                          className={`${styles.addIcon} ${
                            !isSelected(each)
                              ? styles.addIconSelected
                              : styles.addIconNotSelected
                          }`}
                        >
                          <BlueAdd isSelected={isSelected(each)} scale={0.7} />
                        </div>
                      </div>
                    );
                  }
                })}
            </div>
          </div>
        </div>

        {haveNote ? (
          <div className={styles.footer}>
            <div className={styles.caption}>Note</div>
            <div className={styles.textareaContainer}>
              <Textarea
                id="noteTextarea"
                value={noteValue || ""}
                onChange={onChangeNote}
                className={styles.textarea}
                style={{ height: textareaHeight }}
                // ref={textareaRef}
                maxLength={200}
                onKeyDown={handleKeyDown}
                onPaste={(e) => {
                  e.preventDefault(); // Prevent default paste behavior
                  const pastedData = e.clipboardData.getData("text/plain");
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;
                  const currentValue = e.target.value;

                  // Calculate the available space
                  const availableSpace =
                    200 - (currentValue.length - (end - start));

                  // Truncate the pasted data if necessary
                  const truncatedPastedData = pastedData.substring(
                    0,
                    availableSpace
                  );

                  const newValue =
                    currentValue.substring(0, start) +
                    truncatedPastedData +
                    currentValue.substring(end);

                  // Use the existing onChangeNote function to update the state
                  onChangeNote({
                    target: {
                      value: newValue.substring(0, 200), // Ensure it doesn't exceed 200 characters
                    },
                  });

                  // Set cursor position after the pasted text
                  setTimeout(() => {
                    e.target.setSelectionRange(
                      start + truncatedPastedData.length,
                      start + truncatedPastedData.length
                    );
                  }, 0);
                }}
              />

              {(!noteValue || noteValue === "") && (
                <div className={styles.placeholder}>Enter note here</div>
              )}
            </div>
          </div>
        ) : null}

        {haveCovidData ? <CovidDataPicker /> : null}
      </div>

      <AddDataModal
        onSubmit={(e) => {
          handleAdd && addData(e);
        }}
        title={addTitle ? addTitle : "Add new"}
        showModal={isAddOpen}
        hidemodal={() => {
          setAddOpen(false);
        }}
      />
    </>
  );
}

export default DataBoxNote;
